module.exports = __webpack_public_path__ + "static/media/dado2.76be416b.svg";